import { layout } from 'src/styles/layout';
import styled from 'styled-components';

export const CoreValuesContainer = styled.div`
  display: grid;
  max-width: 940px !important;
  row-gap: 6rem;
  margin: 2rem auto 3rem !important;
  padding-left: 24px;
  padding-right: 24px;
`

export const CoreValuesTitle = styled.div`
  display: grid;
  row-gap: 2rem;
`

export const CoreValuesIconography = styled.div`
  display: grid;
  column-gap: 1rem;
  row-gap: 5rem;
  grid-template-columns: repeat(3, 1fr);

  @media all and (max-width: ${layout.md}) {
    grid-template-columns: repeat(2, 1fr);
  }
`

export const CoreValuesIconographyEntry = styled.div`
  display: grid;
  row-gap: 1rem;

  & > div {
    justify-self: center;
  }
`


export const CoreValuesProcessImage = styled.div`
  display: grid;
  width: 209px;

  @media all and (max-width: ${layout.md}) {
    width: 150px;
  }
`
